import type { ReactNode } from 'react';
import { errorMessage } from '../lib/errorMessage';

// Canonical per-section inline error block (see CLAUDE.md "Loading / error /
// empty conventions"): localized failure gets a localized red block with an
// optional Retry button — never a whole-page error overlay.
//
// - `heading` is the lead copy (e.g. "Couldn't load jobs"). When `error` is
//   provided, the message from `errorMessage(error)` is appended after a colon.
// - `children` allows extra custom copy below the heading line.
// - The Retry button renders only when `onRetry` is passed.
export function InlineError({
  heading,
  error,
  onRetry,
  children,
  className,
}: {
  heading: string;
  error?: unknown;
  onRetry?: () => void;
  children?: ReactNode;
  className?: string;
}) {
  return (
    <div
      className={`rounded border border-red-200 bg-red-50 p-4 text-sm text-red-800${
        className ? ` ${className}` : ''
      }`}
    >
      <p className="mb-2">
        {heading}
        {error != null && <>: {errorMessage(error)}</>}
      </p>
      {children}
      {onRetry && (
        <button
          type="button"
          onClick={onRetry}
          className="rounded border border-red-300 bg-white px-2 py-1 text-xs font-semibold text-red-800"
        >
          Retry
        </button>
      )}
    </div>
  );
}
